import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';

import { toList } from '../toList';

export const partnerNamesById = createSelector(getOrganization, function (organization) {
  const result: { [uuid: string]: string } = {};

  if (organization) {
    toList(organization.partnersById).forEach(function (e) {
      result[e.uuid] = e.name;
    });
  }

  return result;
});
